module.exports = __webpack_public_path__ + "img/car-side-bolt.4893683b.svg";